import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DeviceService } from 'src/app/services/devices/device.service';
import { compare } from 'compare-versions';
import { UserService } from 'src/app/services/user/user.service';
import { isAncPlusDevice, isAstroLumDevice } from 'src/app/services/devices/device-type.util';

@Component({
    selector: 'app-all-settings',
    templateUrl: './all-settings.component.html',
    standalone: false
})
export class AllSettingsComponent implements OnInit {

  // 0: "astcal"
  // 1: "sys"
  // 2: "fwupd"
  // 3: "socket"
  // 4: "mqtt"
  // 5: "modulator"
  // 6: "spl"
  // 7: "reqman"
  // 8: "evsm"
  // 9: "network"
  // 10: "rfid"
  // 11: "schedman"
  // 12: "mennekes"
  // 13: "schuko"

  selectedSetting = '';
  loading = false;

  serial: string = '';
  modules: any[] = [];

  connectors: any;

  newInstallSectionCompatible: boolean = false;
  isAdmin = false;
  opt: any
  currentRoute: string = '';
  deviceSubType = '';

  // Propiedades para el modal de error
  showErrorModal: boolean = false;
  errorMessage: string = '';

  constructor(private _device: DeviceService, private _aRoute: ActivatedRoute, private _user: UserService, private router: Router) { }

  ngOnInit(): void {

    this._aRoute.params.subscribe((params: Params) => {
      this.opt = params['option'];
      console.log('params 2' , params);
      switch (this.opt) {
        case 'linkage':
          this.selectedSetting = 'chargVinc';
          break;
        case 'rfid':
          this.selectedSetting = 'rfid';
          break;
        case 'ocpp':
          this.selectedSetting = 'ocpp';
          break;
        case 'power':
          this.selectedSetting = 'power';
          break;
        case 'energyPrice':
          this.selectedSetting = 'energyPrice';
          break;
        case 'chargeScheduler':
          this.selectedSetting = 'scheduler';
          break;
        case 'powerScheduler':
          this.selectedSetting = 'power-scheduler';
          break;
        case 'fwupdate':
          this.selectedSetting = 'fwupdate';
          break;
         case 'ancDeviceSettings':
          this.selectedSetting = 'ancDeviceSettings';
          break;
        case 'bluetooth':
          this.selectedSetting = 'bluetooth';
          break;
        case 'calendar':
          this.selectedSetting = 'calendar';
          break;
        case 'ancPrograms':
          this.selectedSetting = 'ancPrograms';
          break;
        case 'lumScheduler':
          this.selectedSetting = 'lumScheduler';
          break;
        case 'lumAstcal':
          this.selectedSetting = 'lumAstcal';
          break;
        case 'alarms':
          this.selectedSetting = 'alarms';
          break;
        case 'seasons':
          this.selectedSetting = 'seasons';
          break;
        case 'channels':
          this.selectedSetting = 'channels';
          break;
        default:
          this.selectedSetting = '';
          break;
      }
    });


    this._aRoute.parent?.parent?.params.subscribe((params: Params) => {
        this.serial = params['serial']
        var deviceInfo = this._device.getActiveDeviceInfo();
        if(deviceInfo) {
          this.newInstallSectionCompatible = compare(deviceInfo.firmware_version_name, '7.2.0', '>=');
          this.deviceSubType = String(deviceInfo?.sub_type || '').trim();
        } else{
          this._device.getDeviceInfo(this.serial).subscribe(data => {
            this._device.setActiveDeviceInfo(data);
            this.newInstallSectionCompatible = compare(data.firmware_version_name, '7.2.0', '>=');
            this.deviceSubType = String(data?.sub_type || '').trim();
          });
        }
    });

    this.loading = true


    this._device.getModulesByDevice(this.serial).subscribe(data => {
        console.log(data);
        data.forEach(module => {
          this.modules.push(module.topic_name);
        });
        this.loading = false
        console.log(this.modules)
      }, (error) => {
        console.log('Error fetching modules:', error.error);
        this.loading = false;
        this.errorMessage = 'Error al cargar los módulos del dispositivo. Por favor, inténtelo de nuevo.';
        this.showErrorModal = true;
      });

      this._device.getElemDevice(this.serial).subscribe(data => {
          this.connectors=data;
          console.log(data)
        });
  }

  // Método para cerrar el modal de error y redirigir
  closeErrorModal() {
    this.showErrorModal = false;
    this.router.navigate(['/dashboard/device', this.serial]);
  }

  get showAncPrograms(): boolean {
    return isAncPlusDevice({ sub_type: this.deviceSubType, serial: this.serial });
  }

  get showLumScheduler(): boolean {
    return isAstroLumDevice({ sub_type: this.deviceSubType, serial: this.serial });
  }
}
